import { DELETE_PARAM, DELETE_PARAM_SUCCESS, DELETE_PARAM_ERROR} from './actionTypes';

export const deleteParameters = (user, param, history) => {
    return {
        type: DELETE_PARAM,
        payload: {user, param, history }
    }
}

export const deleteParametersSuccess = (message) => {
    return {
        type: DELETE_PARAM_SUCCESS,
        payload: {message}
    }
}

export const deleteParametersError = (param) => {
    return {
        type: DELETE_PARAM_ERROR,
        payload: param
    }
}
